export interface OverlayHitEntry<T> {
  overlay: T;
  zIndex: number;
  area: number;
  index: number;
}

/**
 * Priority order used by canvas hit-testing for overlapping overlays:
 * higher zIndex first, then smaller area (the element the user is most
 * likely aiming at), then later insertion order.
 */
export function sortOverlayHitStack<T>(entries: OverlayHitEntry<T>[]): T[] {
  return [...entries]
    .sort((a, b) => {
      if (a.zIndex !== b.zIndex) return b.zIndex - a.zIndex;
      if (a.area !== b.area) return a.area - b.area;
      return b.index - a.index;
    })
    .map((entry) => entry.overlay);
}

/**
 * Click-again-to-cycle: given the hit stack at a point (highest priority
 * first) and the overlay the click landed on, pick the next overlay down
 * the stack, wrapping back to the top.
 */
export function pickCycleTarget(
  stackIds: string[],
  currentId: string | null
): string | null {
  if (stackIds.length === 0) return null;
  if (!currentId) return stackIds[0];
  const currentIndex = stackIds.indexOf(currentId);
  if (currentIndex === -1) return stackIds[0];
  return stackIds[(currentIndex + 1) % stackIds.length];
}
